/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mock_Agent_Finance_DescInputs */

const en_mk_mock_agent_finance_desc = /** @type {(inputs: Mk_Mock_Agent_Finance_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily cash recap, invoice matching, report drafts.`)
};

const id_mk_mock_agent_finance_desc = /** @type {(inputs: Mk_Mock_Agent_Finance_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekap kas harian, cocokkan tagihan, draf laporan.`)
};

/**
* | output |
* | --- |
* | "Daily cash recap, invoice matching, report drafts." |
*
* @param {Mk_Mock_Agent_Finance_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mock_agent_finance_desc = /** @type {((inputs?: Mk_Mock_Agent_Finance_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mock_Agent_Finance_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mock_agent_finance_desc(inputs)
	return en_mk_mock_agent_finance_desc(inputs)
});